import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ListFacetSharedObject,
  ListFacetValue,
} from '@app/new-search/models/new-search-facets.model';

@Component({
  selector: 'app-list-facet',
  templateUrl: './list-facet.component.html',
  styleUrls: ['./list-facet.component.scss'],
})
export class ListFacetComponent {
  @Input() listFacet: ListFacetSharedObject;
  @Output() facetList = new EventEmitter<ListFacetValue>();

  trackFacetValueId(index: number, facetValue: any) {
    return facetValue.value;
  }

  handleListFacetCheckboxSelection(listFacetValue: ListFacetValue) {
    this.facetList.emit(listFacetValue);
  }
}
